module.exports = __webpack_public_path__ + "media/Instruction_65.9da626fc.mp3";